export default __webpack_public_path__ + "static/media/arrow.9025c6db.svg";